<template>
  <div>
    <super-multi-section-list v-if="!isLoading" :title="title" :multi-section-list="multiSectionList" :component-name="componentName" :close-fn="back"></super-multi-section-list>
  </div>
</template>
<script>
import { get } from 'lodash'
import EventModelClass from '@/common/model/EventModelClass'
import { EventService } from '@/common/api/api.service'
import { GNBDataConverter } from '@/common/converter/ObjectConverter'
import SuperMultiSectionList from '@/views/supermultisection/SuperMultiSectionList'
export default {
  componentName: '',
  components: {
    SuperMultiSectionList
  },
  props: {
  },
  data () {
    return {
      title: '',
      componentName: '',
      multiSectionList: [],
      isLoading: true
    }
  },
  methods: {
    back () {
      const referer = get(this.$route, 'query.referer', '')
      if (referer === '') {
        this.$router.replace('/')
      } else {
        this.$router.replace(referer)
      }
    },
    setData (eventInstance) {
      this.isLoading = true
      EventService.requestEventData(eventInstance).then(({ data }) => {
        const gnb = GNBDataConverter(data)
        this.multiSectionList = get(gnb, 'multiSectionList', [])
        this.title = get(gnb, 'note', '')
        this.componentName = 'BandRouterView'
        this.isLoading = false
      })
    },
    init () {
      let url = get(this.$route, 'query.api', '')
      try {
        if (url !== '') {
          const eventInstance = new EventModelClass({ url: decodeURIComponent(url) })
          this.setData(eventInstance)
        } else {
          let target = '/'
          if (this.$route.params.section !== 'home') {
            target = `/${this.$route.params.section}`
          }
          this.$router.replace(target)
        }
      } catch (e) {
        this.$router.push('/')
      }
    }
  },
  created () {
    this.init()
  }
}
</script>
<style lang="css" scoped>
  .band-view-header {
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 200;
  }
  .band-view-view {
    height: 100vh;
    padding-top: 80px;
  }
  .band-view-view.not-mobile {
    padding-top: 0;
  }
  .band-view-view.not-mobile,
  .band-view-view-oksusu.not-mobile{
    padding-top: 0;
  }
  .band-view-view-oksusu {
    padding-top: 40px;
  }
</style>
